import { isInIframe } from '@shared/utils/isInIframe';
import { useEventUserRole } from '@shared/components/AuthProvider';
import { useGuestPageContainerBySlugQuery } from '../Custom.graphql.generated';

// Cache alignment: useFetchCustomPageData (SSR prefetch) fires the same query with
// pageSlug derived from useCurrentPageSlug(). The widget receives pageSlug from route
// params via the same URL, so the Apollo cache keys match.
export const useCustomData = (_eventId: string, eventHandle: string, pageSlug: string) => {
  const isPreviewing = isInIframe();
  const { isAdmin } = useEventUserRole();

  const {
    data: pageContainerData,
    loading,
    error,
  } = useGuestPageContainerBySlugQuery({
    variables: {
      payload: {
        eventName: eventHandle,
        pageSlug: pageSlug,
      },
      isAdminDashboard: isPreviewing && isAdmin,
    },
    batchMode: 'fast',
    fetchPolicy: 'cache-first',
    notifyOnNetworkStatusChange: false,
    // Page content is always below the fold — no need to fetch during SSR.
    ssr: false,
    // Skip the query when pageSlug is empty to avoid sending invalid payloads
    // to event_service, which rejects empty pageSlug with a validation error.
    skip: !pageSlug,
  });

  return {
    loading,
    pageContainerBySlug: pageContainerData?.pageContainerBySlug,
    error,
    isAdmin,
  };
};
